// extracted by mini-css-extract-plugin
export default {"card":"hyFYsOIMp2xRV1dBYz_O","icon":"Ku0oIfogq2Z0ImF0QAeD","header":"k23NFtCGy8JwLyoBaNPd","title":"Gl19QbKnqSoOcUDUezwD","subtitle":"oPTolcvoDhFXTQKi21fS"};